import { useReducer } from 'react';
import { IRecordingState, Recorder, RecordingStateActions, UploadStatus, WorkflowSteps } from '../models';
import IRecordingStateReducerAction from './IRecordingStateReducerAction';

export const initialRecordingState: IRecordingState = {
  step: WorkflowSteps.Setup,
  recorder: new Recorder()
};

export default function useRecordingState() {
  const [state, dispatch] = useReducer(reducer, initialRecordingState);
  return {
    state,
    dispatch
  };
}

const reducer = (state: IRecordingState, action: IRecordingStateReducerAction): IRecordingState => {
  switch (action.type) {
    case RecordingStateActions.Initialize:
      return initialRecordingState;

    case RecordingStateActions.ChangeStep: {
      if (action.payload === WorkflowSteps.Setup) {
        return { ...initialRecordingState };
      }

      return { ...state, step: action.payload };
    }
    case RecordingStateActions.SetTargetFolder:
      return {
        ...state,
        targetFolder: action.payload
      };

    case RecordingStateActions.SetFileName: {
      return {
        ...state,
        fileName: action.payload
      };
    }
    case RecordingStateActions.StartUpload:
      return { ...state, uploadStatus: UploadStatus.Uploading };

    case RecordingStateActions.CompleteUpload:
      return {
        ...state,
        uploadStatus: action.payload ? UploadStatus.Success : UploadStatus.Failure
      };

    case RecordingStateActions.HandleError:
      return {
        ...state,
        step: WorkflowSteps.Error
      };

    default:
      throw Error(`Invalid action type ${action.type}`);
  }
};
